"use client"

import { useEffect } from "react"

// Shows the hairline scrollbar (app/globals.css, "Scrollbars") on whatever is
// scrolling, for a moment after it stops. CSS can't tell that something is
// being scrolled, so this marks it data-scrolling and clears the mark 900ms
// after the last scroll. The page itself is marked on <html>.
export function ScrollReveal() {
  useEffect(() => {
    const timers = new Map<Element, number>()
    const onScroll = (e: Event) => {
      const el = e.target === document ? document.documentElement : (e.target as Element)
      if (!(el instanceof Element)) return
      el.setAttribute("data-scrolling", "")
      window.clearTimeout(timers.get(el))
      timers.set(
        el,
        window.setTimeout(() => {
          el.removeAttribute("data-scrolling")
          timers.delete(el)
        }, 900),
      )
    }
    document.addEventListener("scroll", onScroll, { capture: true, passive: true })
    return () => {
      document.removeEventListener("scroll", onScroll, { capture: true } as EventListenerOptions)
      timers.forEach((t) => window.clearTimeout(t))
    }
  }, [])
  return null
}
